import React from 'react';
import { useController } from 'react-hook-form';
import { UploadDocumentsBox } from '@/components';
import { Body3Light } from '@/ui';
import { COLORS } from '@/utils/static';

export const FileUploadForm = ({ form, label, required, question, isReadTooltip }) => {
  const {
    field: { ref, ...field },
    fieldState: { error }
  } = useController({
    ...form,
    rules: {
      required: required,
      validate: (value) => {
        return true;
      }
    },
    defaultValue: null
  });

  return (
    <div>
      <UploadDocumentsBox
        label={label}
        tooltip={question ? question.tooltip : ''}
        tooltip_RU={question ? question.tooltip_RU : ''}
        tooltip_LV={question ? question.tooltip_LV : ''}
        required={required}
        extensions={question.availableExtensions}
        maxSize={question.maxSize}
        docs={field.value ? [field.value] : []}
        setDocs={(files) => field.onChange(files)}
        isReadTooltip={isReadTooltip}
        buttonProps={{
          style: {
            width: '120px'
          }
        }}
        hideLastBorder
      />

      {error && (
        <Body3Light $color={COLORS.red} $marginTop={12}>
          {error.message}
        </Body3Light>
      )}
    </div>
  );
};
